/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class AccountValueGrid extends SiteEntityGrid<AccountValueRow, any> {
        protected getColumnsKey() { return 'Data.AccountValue'; }
        protected getDialogType() { return AccountValueDialog; }
        protected getIdProperty() { return AccountValueRow.idProperty; }
        protected getLocalTextPrefix() { return AccountValueRow.localTextPrefix; }
        protected getService() { return AccountValueService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}